import { OrdersPanel } from '@/pages/Dashboard/panels/OrdersPanel'
import { Vertical } from '@gravitate-js/excalibrr'

export function OrderManagement() {
  return (
    <Vertical className='h-full w-full'>
      <OrdersPanel />
    </Vertical>
  )
}
